import { render, staticRenderFns } from "./group-settings-editor.vue?vue&type=template&id=6da63608&"
import script from "./group-settings-editor.vue?vue&type=script&lang=js&"
export * from "./group-settings-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports